import { Component, OnInit, Input, ViewChildren, ElementRef, QueryList, OnChanges, SimpleChanges } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ApiService } from '../../itinerary/shared/api.service';
import { ItineraryService } from '../../shared/itinerary.service';
import { UserService } from '../../pages/com.usblick.common/auth/user.service';
import { setting } from '../../../../setting';
import CssFilterConverter from 'css-filter-converter';

@Component({
  selector: 'usb-data-itinerary',
  templateUrl: './data-itinerary.component.html',
  styleUrls: ['./data-itinerary.component.scss'],
  providers: [DatePipe]
})
export class DataItineraryComponent implements OnInit, OnChanges {

  @Input() itinerary: any;
  @Input() screen: any;
  @Input() idReservation: any;
  @Input() idConfirmation: any;
  @Input() payloadSearch: any;
  @Input() formTransports: any;
  payloadSearchTransportFly: any;
  formTransportsFly: any;
  @ViewChildren('icons', { read: ElementRef }) icons : QueryList<ElementRef>;
  clientData: any;
  arrival: string;
  departure: string;
  nigths: number = 0;
  adults: number = 0;
  children: number = 0;
  destinySecuency: string;
  flyQty:string = '0';
  public totalAdults: number;
  public totalChildren: number;
  qtyNights:number = 0;
  qtyDays:number = 0;
  tooltipFlight: boolean = false;
  colorFlight: string;
  flightsInternal: any[] = [];
  private _lastFlights: any[] = [];
  private _cachedResult: any[] = [];

  public getClientsSettingAppBooking: any;
  timeArrive:string;
  timeDropoff:string;

  constructor(
    private datePipe: DatePipe,
    private apiService: ApiService,
    public itineraryService: ItineraryService,
    public userService:UserService)
    {
      this.clientData = {
        name: null,
        mail: null,
        phone: null
      };
      this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
    }

  ngOnChanges(changes: SimpleChanges): void {


    // Si cambia el itinerary completo
  if (changes['itinerary'] ) {
    const currentItinerary = changes['itinerary'].currentValue;
    const previousItinerary = changes['itinerary'].previousValue;

    // Ejecutar métodos que dependen del itinerary
    this.getFlyItinerariesInternal();
    this.setTransportFlightContext();

    // Verificar si cambió la propiedad 'items' dentro del itinerary
    if (previousItinerary?.items !== currentItinerary?.items) {

      // Solo ciudades del itinerary.destination. No se antepone el origin del
      // transporte para no mostrar el nombre del aeropuerto/hotel del pickup.
      this.destinySecuency = this.getDestinySecuency(currentItinerary.destination);
      this.onItemsChange(currentItinerary?.items, previousItinerary?.items);
      this.getQtyPax(currentItinerary?.items);
    }
  }
  }


private onItemsChange(currentItems: any[], previousItems: any[]): void {
  // Lógica específica cuando cambian los items
  this.getQtyPax(currentItems);


}

  ngOnInit() {
    this.colorFlight = this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;
    this.getClientData();


    if (this.itinerary && this.itinerary.items && Array.isArray(this.itinerary.items)) {

      let arrivalDates = [];
      let departureDates = [];

      this.totalAdults = this.itinerary.items.reduce((sum, item) => sum + (item.paxAdults || 0), 0);
      this.totalChildren = this.itinerary.items.reduce((sum, item) => sum + (item.paxChildren || 0), 0);

      this.itinerary.items.forEach(date => {
        arrivalDates.push(date.arrivalDate);
        departureDates.push(date.departureDate);
      });

      arrivalDates.sort();
      departureDates.sort().reverse();

      this.arrival = this.itinerary.arrivalDate ;
      this.departure = this.itinerary.departureDate ;
      // Solo ciudades del itinerary.destination. No se antepone el origin del
      // transporte para no mostrar el nombre del aeropuerto/hotel del pickup.
      this.destinySecuency = this.getDestinySecuency(this.itinerary.destination);
      this.getQtyPax(this.itinerary.items);
      this.getFlyItinerary();
      this.getFlyItinerariesInternal();
      this.getQtyPax(this.itinerary.items);

    }else{
      console.log("error itinerary");
    }
    this.nightsAndDays();
    this.getTimeArrive();
    this.setTransportFlightContext();

  }

  private setTransportFlightContext(): void {
    const transportItems = this.itinerary?.items?.filter(item => item.category_id === 8) || [];
    const fly = this.itinerary?.flights?.[0] || this.itinerary?.fly;

    const item = transportItems.find(transport => {
      const transfers = transport.payload?.[0]?.transfers;
      return transfers && (
        (transfers.pickupLocation?.type === 'airport' && !fly?.flyNumberIn) ||
        (transfers.dropoffLocation?.type === 'airport' && !fly?.flyNumberOut)
      );
    }) || transportItems.find(transport => transport.payload?.[0]?.transfers);

    this.payloadSearchTransportFly = item?.payload || this.payloadSearch;
    this.formTransportsFly = item?.formTransport || this.formTransports;
  }

getQtyPax(items: any[]): void {
  if (items.length === 0) {
    return;
  }

  let maxAdults = 0;
  let maxChildrens = 0;

    // ✅ Obtener edades CON su fecha de llegada
  const childrenWithDates = this.getChildrenAgesWithDate(items);

  const childrensFormInitial = this.getChildrenAgesWithDate(items);

  items.forEach(item => {
    const adultsNum = Number(item.paxAdults);
    const childrensNum = Number(item.paxChildren);

    if (adultsNum > maxAdults) {
      maxAdults = adultsNum;
    }

    if (childrensNum > maxChildrens) {
      maxChildrens = childrensNum;

    }
  });

  this.adults = maxAdults;
  this.children = childrensFormInitial.length;

}



getChildrenAgesWithDate(items: any): { age: number, arrivalDate: Date, arrivalDateString: string}[] {
  const result: { age: number, arrivalDate: Date, arrivalDateString: string }[] = [];


  // ✅ Contar cuántos firstWay 1 y firstWay 2 hay
  const firstWay1Items = items.filter(i => i.category_id === 8 && i.firstWay === 1);
  const firstWay2Items = items.filter(i => i.category_id === 8 && i.firstWay === 2);


  // ✅ Determinar qué firstWay procesar
  // Si hay firstWay1 y firstWay2, solo procesar firstWay1 (ida y vuelta simplificado)
  const processFirstWay1 = firstWay1Items.length > 0;
  const processFirstWay2 = firstWay2Items.length > 0 && firstWay1Items.length === 0;


  for (const item of items) {
    // ✅ Saltar firstWay2 si también hay firstWay1 (ida y vuelta simplificado)
    if (item.category_id === 8 && item.firstWay === 2 && firstWay1Items.length > 0) {
      continue;
    }

    // ✅ Saltar firstWay1 si no hay ninguno (no debería pasar)
    if (item.category_id === 8 && item.firstWay === 1 && firstWay1Items.length === 0) {
      continue;
    }

    const currentDateStr = new Date().toISOString().split('T')[0];
    const categoryId = item.category_id;
    let payloadUpdate;
    let arrivalDate: Date | null = null;

    if (item.arrivalDate) {
      arrivalDate = this.normalizeDate(currentDateStr);
    }

    if (!arrivalDate) {
      arrivalDate = this.normalizeDate(item.dateIni);
    }

    if (!arrivalDate) {
      console.warn(`Item ${item.id} sin fecha de llegada`);
      continue;
    }

    if (item.category_id === 8) {
      payloadUpdate = item.payloadSync;
    } else {
      payloadUpdate = item.payloadUpdate;
    }

    if (item.category_id !== 8 && (!payloadUpdate || !payloadUpdate.products || payloadUpdate.products.length === 0)) {
      continue;
    }

    if (item.category_id === 8 && !payloadUpdate) {
      continue;
    }

    let ages: number[] = [];
    switch (categoryId) {
      case 1: // HOTELES
        const roomConfigurations = payloadUpdate.products[0]?.others?.hotels?.roomConfiguration;
        if (roomConfigurations && Array.isArray(roomConfigurations)) {
          for (const room of roomConfigurations) {
            if (room.children && Array.isArray(room.children)) {
              ages.push(...room.children.map((age: any) => Number(age)));
            }
          }
        }
        break;

      case 2: // RENT A CAR
        const rentAcarChildren = payloadUpdate.childAge;
        if (rentAcarChildren && Array.isArray(rentAcarChildren)) {
          ages = rentAcarChildren.map((age: any) => Number(age));
        }
        break;

      case 6: // TOURS / EXPERIENCIAS
        const tourChildren = payloadUpdate.products[0]?.others?.tours?.children;
        if (tourChildren && Array.isArray(tourChildren)) {
          ages = tourChildren.map((age: any) => Number(age));
        }
        break;

      case 8: // TRANSPORTS / TRASLADOS
        const transferChildren = payloadUpdate.transfers?.paxList?.children;
        if (transferChildren && Array.isArray(transferChildren)) {
          ages = transferChildren.map((age: any) => Number(age));
        }
        break;

      case 9: // TICKETS
        const ticketChildren = payloadUpdate.products[0]?.others?.tours?.children;
        if (ticketChildren && Array.isArray(ticketChildren)) {
          ages = ticketChildren.map((age: any) => Number(age));
        }
        break;

      case 10: // ASISTENCIA / PAQUETES
        const assistanceChildren = payloadUpdate.products[0]?.insurances?.paxList?.paxAges?.filter((c: any) => c < 18) || [];
        if (assistanceChildren && Array.isArray(assistanceChildren)) {
          ages = assistanceChildren.map((age: any) => Number(age));
        }
        break;
    }



    for (const age of ages) {
      result.push({
        age: age,
        arrivalDate: arrivalDate,
        arrivalDateString: currentDateStr
      });
    }
  }


  return result;
}

// /**
//  * Obtiene todas las edades de niños con su fecha de llegada correspondiente
//  * @param items - Lista de items del itinerario
//  * @returns Array de objetos con edad y arrivalDate
//  */
// getChildrenAgesWithDate(items: any): { age: number, arrivalDate: Date, arrivalDateString: string}[] {
//   const result: { age: number, arrivalDate: Date, arrivalDateString: string }[] = [];

//   for (const item of items) {

//     const currentDateStr = new Date().toISOString().split('T')[0];
//     const categoryId = item.category_id;
//     let payloadUpdate;
//     // ✅ Normalizar la fecha correctamente
//     let arrivalDate: Date | null = null;

//     if (item.arrivalDate) {
//       arrivalDate = this.normalizeDate(currentDateStr);

//     }

//     if (item.dateIni) {
//       arrivalDate = this.normalizeDate(item.dateIni);

//     }

//     if (!arrivalDate) {
//       console.warn(`Item ${item.id} sin fecha de llegada`);
//       continue;
//     }

//     if (!arrivalDate) {
//       console.warn(`Item ${item.id} sin fecha de llegada`);
//       continue;
//     }

//     if (item.category_id === 8) {
//       payloadUpdate = item.payloadSync;
//     } else {
//       payloadUpdate = item.payloadUpdate;
//     }

//     if (!payloadUpdate || !payloadUpdate.products || payloadUpdate.products.length === 0) {
//       continue;
//     }

//     let ages: number[] = [];
//     switch (categoryId) {
//       case 1: // HOTELES
//         const roomConfigurations = payloadUpdate.products[0]?.others?.hotels?.roomConfiguration;
//         if (roomConfigurations && Array.isArray(roomConfigurations)) {
//           for (const room of roomConfigurations) {
//             if (room.children && Array.isArray(room.children)) {
//               ages.push(...room.children.map((age: any) => Number(age)));
//             }
//           }
//         }
//         break;

//       case 2: // RENT A CAR
//         const rentAcarChildren = payloadUpdate.childAge;
//         if (rentAcarChildren && Array.isArray(rentAcarChildren)) {
//           ages = rentAcarChildren.map((age: any) => Number(age));
//         }
//         break;

//       case 6: // TOURS / EXPERIENCIAS
//         const tourChildren = payloadUpdate.products[0]?.others?.tours?.children;
//         if (tourChildren && Array.isArray(tourChildren)) {
//           ages = tourChildren.map((age: any) => Number(age));
//         }
//         break;

//       case 8: // TRANSPORTS / TRASLADOS
//         const transferChildren = payloadUpdate.products[0]?.others?.transfers?.paxList?.children;
//         if (transferChildren && Array.isArray(transferChildren)) {
//           ages = transferChildren.map((age: any) => Number(age));
//         }
//         break;

//       case 9: // TICKETS
//         const ticketChildren = payloadUpdate.products[0]?.others?.tours?.children;
//         if (ticketChildren && Array.isArray(ticketChildren)) {
//           ages = ticketChildren.map((age: any) => Number(age));
//         }
//         break;

//       case 10: // ASISTENCIA / PAQUETES
//         const assistanceChildren = payloadUpdate.products[0]?.insurances?.paxList?.paxAges?.filter((c: any) => c < 18) || [];
//         if (assistanceChildren && Array.isArray(assistanceChildren)) {
//           ages = assistanceChildren.map((age: any) => Number(age));
//         }
//         break;
//     }
//     // Agregar cada edad con su arrivalDate correspondiente
//     for (const age of ages) {
//       result.push({
//         age: age,
//         arrivalDate: arrivalDate,
//         arrivalDateString : currentDateStr
//       });
//     }

//   }

//   return result;
// }

private normalizeDate(dateStr: string, subtractOneDay: boolean = true): Date | null {

  if (!dateStr) return null;

  const parts = dateStr.split('T')[0].split('-');
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const day = parseInt(parts[2], 10);

  let date = new Date(Date.UTC(year, month, day, 12, 0, 0));

  if (subtractOneDay) {
    date.setUTCDate(date.getUTCDate() - 1);
  }

  return date;
}




  getFlyItinerary(){

    this.apiService.doGet('itinerary/' + this.itinerary.id +'/fly').subscribe(
    //this.apiService.doGet('fly_itineraries').subscribe(
      (response:any) => {
        //console.log('Reservas', response);

        if(response == undefined){
          this.flyQty = '0';
        }else{
          this.flyQty = '1';
        }
      },
      error => {
        console.log("vuelo error", error);
        this.flyQty = '0';
      }
    );

  }


  destinationsPerItinerary(): string {
    let destinations = '';
    if (this.itinerary.destination.length > 0) {
      this.itinerary.destination.forEach((destination, index) => {
        destinations = destinations.concat(index === 0 ?
        (destination.destination_info.cityName ? destination.destination_info.cityName : destination.iata_code)
        : ' > ' + (destination.destination_info.cityName ? destination.destination_info.cityName : destination.iata_code));
      });
    } else {
      destinations = 'Any destination';
    }
    return destinations;
  }


 /**
   * get string secuency destinys
   * @param destinys
   */

  /**
   * Patrones que NO son ciudades: hoteles, aeropuertos, hostels, etc.
   * Si cityName del backend trae alguno de estos strings (ej: "Hotel Hilton Madrid"),
   * lo descartamos para que el header muestre solo el nombre de la ciudad real.
   */
  private static readonly NON_CITY_PATTERNS = [
    /\bhotel\b/i,
    /\bapart(amento|ment)?\b/i,
    /\bhostal\b/i,
    /\bhostel\b/i,
    /\binn\b/i,
    /\bresort\b/i,
    /\baeropuerto\b/i,
    /\bairport\b/i,
  ];

  /** Devuelve true si el string parece ser un código IATA de 3 letras mayúsculas. */
  private static isIataCode(value: string): boolean {
    return /^[A-Z]{3}$/.test(value.trim());
  }

  getDestinySecuency(destinys: Array<any>, _origin?: string | any): string {

    this.nigths = 0;
    this.adults = 0;
    this.children = 0;
    const cities: string[] = [];

    // Solo ciudades del itinerary.destination. El parámetro `origin` se ignora
    // a propósito: el nombre del aeropuerto/hotel del pickup no debe anteponerse
    // al listado de ciudades del viaje.

    if (destinys && destinys.length > 0) {
      for (let i = 0; i < destinys.length; i++) {
        this.nigths += parseInt(destinys[i].destination_info?.nights ?? '0');

        const raw = destinys[i]?.destination_info?.cityName;
        if (!raw) {
          continue;
        }
        // Filtramos cualquier string que parezca hotel / aeropuerto / hostel, etc.
        const isNonCity = DataItineraryComponent.NON_CITY_PATTERNS.some(rx => rx.test(raw));
        // Filtramos también códigos IATA puros (3 letras mayúsculas).
        const isIata = DataItineraryComponent.isIataCode(raw);
        if (isNonCity || isIata) {
          continue;
        }
        cities.push(raw);
      }
    }

    // Deduplicar manteniendo el orden de primera aparición
    const seen = new Set<string>();
    const uniqueCities = cities.filter(city => {
      const key = city.toUpperCase();
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });

    return uniqueCities.join(' > ').toUpperCase();
  }



  getReservations() {
    this.apiService.doGet('reservations/').subscribe(
      (response:any) => {
        //console.log('Reservas', response);
      },
      error => {
        console.log(error);
      });
  }
  getDatesRange() {
    const destination = this.itinerary.destination;
    if (destination.length > 0) {
      const arrival = this.itinerary.arrivalDate ?
      this.datePipe.transform(this.itinerary.arrivalDate.toString(), 'MMM dd, yyyy') :
      this.datePipe.transform(this.itinerary.arrivalDate.toString(),
         'MMM dd, yyyy');
      const departure = destination.length === 0 ? '' : ' to ' +
      this.datePipe.transform(this.itinerary.departureDate.toString(),
         'MMM dd, yyyy');
      return arrival + departure;
    } else {
      return 'Dates not defined';
    }
  }

  getClientData() {
    const client = this.itinerary.clients;
    if(client==null){
      const name = '';
      const email = '';
      const phone = '';
      return 'Personal information not available';
    }
    this.clientData.name = client.first_name !== 'false' ? client.first_name + ' '  + (client.last_name==null ? '' : client.last_name) : '';
    this.clientData.email = client.email ? client.email : null;
    this.clientData.phone = client.phone ? client.phone : null;
  }

  existHotel(){
    if(this.userService.itineraryActive.length > 0){
      if(this.userService.itineraryActive[0].items.length>0){
        let exist = this.userService.itineraryActive[0].items.find( element => element.categoryName == "HOTELS" );

        if(exist){
          return true;
        }else{
          return false;
        }
      }
    }
  }

  nightsAndDays():void{
    this.qtyNights = this.itinerary.nights;
    this.qtyDays = this.itinerary.nights + 1;
  }

  getFlyItinerariesInternal(): void {
    if(this.itinerary.flights && this.itinerary.flights.length > 0) {
       const dataCopy = [...this.itinerary.flights];
       const firstFlight = dataCopy.shift(); // Remueve el primer elemento

       this.flightsInternal = dataCopy;
    }
  }

   getHourFly(dateTime: any): string {
      if (dateTime) {
        return dateTime.slice(11, 16); // 'HH:MM' empieza en el índice 11
      }
      return '';
   }

   afterDateFlyOut(dateFlyIn: string, dateFlyOut: string): string {
    const inDate = new Date(dateFlyIn);
    const outDate = new Date(dateFlyOut);

    // Diferencia en milisegundos
    const diffTime = outDate.getTime() - inDate.getTime();

    // Convertimos la diferencia a días, horas y minutos
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));

    if (diffDays > 0) {
        return `(+${diffDays} día${diffDays > 1 ? 's' : ''})`;
    } else {
        return `(+${diffHours}:${diffMinutes.toString().padStart(2, '0')} hs.)`;
    }
}

/**
 * Controla la visibilidad del tooltip de vuelo y aplica filtros de color cuando se muestra
 *
 * Este método gestiona el estado de visualización del tooltip y cuando se activa (event = true),
 * aplica filtros CSS personalizados a los íconos basados en el color configurado para vuelos.
 *
 * @param {boolean} event - Estado de visibilidad del tooltip (true = visible, false = oculto)
 * @returns {void}
 *
 * @actions
 * - Actualiza el estado de tooltipFlight
 * - Cuando se muestra (event = true), ejecuta applyImageFilter()
 *
 * @sideEffects
 * - Modifica tooltipFlight con el nuevo estado
 * - Ejecuta applyImageFilter() que modifica estilos CSS de íconos
 *
 * @example
 * // Mostrar tooltip y aplicar filtros:
 * this.changeTooltipFlightVisible(true);
 *
 * // Ocultar tooltip:
 * this.changeTooltipFlightVisible(false);
 */
changeTooltipFlightVisible(event: boolean): void {
  if(event) {
     this.applyImageFilter();
  }

  this.tooltipFlight = event;
}

  /**
 * Aplica filtros CSS personalizados a íconos basados en el color de vuelo configurado
 *
 * Este método convierte un color hexadecimal a filtros CSS equivalentes y los aplica
 * a los íconos de vuelo, específicamente al primero y último ícono de la lista.
 *
 * @returns {void}
 *
 * @process
 * 1. Convierte hex color a filtros CSS usando CssFilterConverter
 * 2. Extrae y formatea los filtros de color
 * 3. Aplica los filtros a los íconos con setTimeout para evitar conflictos de renderizado
 *
 * @uses CssFilterConverter.hexToFilter() - Conversor de hex a filtros CSS
 * @uses setTimeout(0) - Para aplicar estilos después del ciclo de renderizado actual
 *
 * @targetElements
 * - Primer ícono (index = 0)
 * - Último ícono (index = icons.length - 1)
 *
 * @styling
 * - filter: Aplica los filtros de color convertidos
 * - width: 40px - Establece ancho fijo para los íconos
 *
 * @dependencies
 * - Requiere this.colorFlight configurado con color hexadecimal
 * - Requiere this.icons con referencias a elementos DOM
 */
    applyImageFilter() {
      const color = this.colorFlight;
      const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });

      //Extraemos el literal en String de la conversión
      const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(" ");

      // Convierte el color a un objeto de filtro de CSS y extrae los filtros de la respuesta color del resultado.
      const colorRegex = /color\((.*)\)/;
      const colorMatch = tempFilterStr.match(colorRegex);
      const colorFilter = colorMatch ? colorMatch[1] : "";

      const filter = colorFilter;

      // Establece el atributo de estilo "filter" en el elemento de imagen con los filtros de color extraídos.
      setTimeout(() => {

        this.icons.forEach(((icon, index) => {
          if(index === 0 || index === this.icons.length - 1) {
            icon.nativeElement.setAttribute('style', `filter: ${filter}; width: 40px;`);
          }
        }));
      }, 0);
    }


getActualFlyInternal(flights: any[], value: string): any {
  if (!flights || flights.length < 1) {
    return null;
  }

  // Descartar primer y último elemento
  const middleFlights = flights;
  const currentDate = new Date();

  // 1. Buscar vuelo actual (en curso)
  const currentFlight = middleFlights.find(flight => {
    try {
      if (!flight?.departureOut || !flight?.arrivalOut) return false;

      const departure = new Date(flight.departureOut);
      const arrival = new Date(flight.arrivalOut);

      return currentDate >= departure && currentDate <= arrival;
    } catch (error) {
      console.error('Error procesando vuelo:', flight, error);
      return false;
    }
  });

  if (currentFlight && currentFlight[value]) {
    return currentFlight[value];
  }

  // 2. Si no hay vuelo actual, buscar próximo vuelo
  const nextFlight = middleFlights
    .filter(flight => flight?.departureOut)
    .sort((a, b) => new Date(a.departureOut).getTime() - new Date(b.departureOut).getTime())
    .find(flight => new Date(flight.departureOut) > currentDate);

  return nextFlight ? nextFlight[value] : null;
}



getDataTooltip(fly: any, index: number, value: string): string {
  const position = this.getPosition(index);
  return this.getDataFlyValue(fly, value, position);
}

private getPosition(index: number): 'first' | 'middle' | 'last' {
  const lastIndex = this.getFlyArr(this.itinerary?.flights).length - 1;

  if (index === 0) return 'first';
  if (index === lastIndex) return 'last';
  return 'middle';
}

private getDataFlyValue(fly: any, value: string, position: 'first' | 'middle' | 'last'): string {
  const valueMap = {
    iata: {
      first: () => fly.airportIataCodeIn,
      middle: () => fly.iataCityArrivalOut,
      last: () => fly.airportIataCodeOut
    },
    date: {
      first: () => fly.arrivalIn,
      middle: () => fly.arrivalOut,
      last: () => fly.departureOut
    }
  };

  return valueMap[value]?.[position]?.() || '';
}


getFlyArr(flights: any[]): any[] {

  if (!flights || flights.length === 0) return [];

  // Verificar si los flights han cambiado
  const hasChanged = this.hasFlightsChanged(flights);

  if (!hasChanged && this._cachedResult.length > 0) {
    return this._cachedResult;
  }

  // Calcular nuevo resultado: todos los vuelos originales + primer vuelo al final
  const result = [...flights]; // Copiar todos los vuelos originales

  // Agregar el PRIMER vuelo otra vez como "último" elemento
  if (flights[0]) {
    result.push(flights[0]);
  }

  // Actualizar cache
  this._lastFlights = [...flights];
  this._cachedResult = result;

  return result;
}

private hasFlightsChanged(newFlights: any[]): boolean {
  if (this._lastFlights.length !== newFlights.length) return true;

  for (let i = 0; i < newFlights.length; i++) {
    if (this._lastFlights[i]?.id !== newFlights[i]?.id) {
      return true;
    }
  }

  return false;
}

getTimeArrive():void{


  const itemsArr = this.userService.itineraryActive || [];


  if(!itemsArr || itemsArr.length === 0) {
      return;
    }


    const initArrive = itemsArr.items;
    let pickupTime:string;
    let dropoffTime:string;
    if(!initArrive || initArrive.length === 0) {
      return;
    }

      initArrive.forEach((arrive:any) => {
      if(arrive.categoryName === 'TRANSPORTS'){
        pickupTime = arrive.payload[0].transfers.pickupTime;
        dropoffTime = arrive.payload[0].transfers.dropoffTime;
        }
      });

    this.timeArrive = pickupTime != null ? `- ${pickupTime} hs` : '';
    this.timeDropoff = dropoffTime != null ? `- ${dropoffTime} hs` : '';



}


}
